export default {
  address: {
    "full_name": "",
    "phone_number": "",
    "company_name": "",
    "address_line1": "",
    "address_line2": "",
    "city": "",
    "state_or_region": "",
    "postal_code": "",
    "country_code": "US",
    "billingDifferent": false
  },
  billing_address: {
    "full_name": "",
    "first_name": "",
    "phone_number": "",
    "company_name": "",
    "address_line1": "",
    "address_line2": "",
    "city": "",
    "state_or_region": "",
    "postal_code": "",
    "country_code": "US"
  },
  payment_info: {},
  contact: {},
  hasAcceptedItems: false,
  hasAnyAccepted: false,
  checkout_settings: {},
  allow_pay_later: false,
  contact_name_required: false,
  contact_phone_required: false,
  total_order: 0
}